// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 634 ? "2c796e83" : chunkId) + "." + {"634":"edcfc8a94e091349","651":"3a61127a96893fb0"}[chunkId] + ".js";
};